function getGraphType(type) {
    switch (type) {
        case "rainfall-sensor":
            return "bar";
        default:
            return "area";
    }
}

export default getGraphType;